import { twMerge } from 'tailwind-merge';
import { Toggle, ToggleProps } from './Toggle';

export interface ToggleWithLabelProps extends ToggleProps {
  header: string;
  subHeader?: string;
  className?: string;
  headersWrapperClassName?: string;
  headerClassName?: string;
  subHeaderClassName?: string;
  toggleClassName?: string;
}

export const ToggleWithLabel = ({
  header,
  subHeader,
  className,
  headersWrapperClassName,
  headerClassName,
  subHeaderClassName,
  toggleClassName,
  ...props
}: ToggleWithLabelProps) => (
  <div className={twMerge('flex items-start justify-between gap-4', className)}>
    <div className={twMerge('space-y-2', headersWrapperClassName)}>
      <p className={twMerge('self-stretch text-xl font-bold leading-[30px] text-gray-800', headerClassName)}>
        {header}
      </p>
      <p className={twMerge('self-stretch text-sm font-medium leading-tight text-stone-500', subHeaderClassName)}>
        {subHeader}
      </p>
    </div>
    <Toggle className={toggleClassName} {...props} />
  </div>
);
